import { rem } from 'polished';
import styled, { breakpoints } from 'src/styles/theme';
import ModalTrimTemplate from './ModalTrimTemplate';

export const ModalTrimStyled = styled(ModalTrimTemplate)`
    color: ${({ theme }) => theme.colors.black};
    font-size: ${({ theme }) => theme.fontSizes.textBase};

    .sticky {
        position: sticky;
        top: -${rem(9)};
        display: flex;
        background: ${({ theme }) => theme.colors.white};
        width: 100vw;

        @media (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(20)};
        }

        .trim {
            min-width: ${rem(300)};
            padding: ${rem(20)} 0;
            background: ${({ theme }) => theme.colors.white};

            .trimName {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }
        }
    }

    .trims {
        margin: 0 0 ${rem(30)} 0;
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey16};

        .title {
            font-size: ${rem(25)};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            position: absolute;
            top: ${rem(30)};
        }

        @media (min-width: ${breakpoints.md}px) {
            margin: 0 0 ${rem(30)} ${rem(20)};
        }

        .sections {
            display: flex;
            padding: ${rem(20)} 0 ${rem(40)} 0;

            .trim {
                width: ${rem(280)};
                margin-right: ${rem(25)};
                display: flex;
                flex-direction: column;
                
                .trimImage {
                    width: ${rem(250)};
                    padding-top: ${rem(30)};
                }

                .trimPromo {
                    padding-top: ${rem(50)};
                    text-align: right;

                    @media (min-width: ${breakpoints.md}px) {
                        padding-top: ${rem(35)};
                    }
                }

                .trimPromoSpace {
                    margin-top: ${rem(35)};
                    height: ${rem(40)};
                }

                .trimName {
                    font-size: ${({ theme }) => theme.fontSizes.textMedium};
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    padding-top: ${rem(15)};
                    display: block;
                }

                .trimLabel {
                    padding: ${rem(15)} 0 ${rem(5)} 0;
                    display: block;
                }

                .trimDescription {
                    color: ${({ theme }) => theme.colors.grey31};
                    display: block;
                    height: ${rem(40)};
                    margin-top: auto;
                }
                
                .alignToBottom {
                    margin-top: auto;
                }

                .trimPrice {
                    padding: ${rem(25)} 0;
                    display: block;
                    line-height: ${rem(18)};
                    height: ${rem(85)};

                    .monthlyPrice {
                        white-space: nowrap;
                    }
                }

                button {
                    width: 100%;
                    border: 1px solid ${({ theme }) => theme.colors.black};
                    text-transform: uppercase;
                    background: none;
                    padding: ${rem(15)};
                    cursor: pointer;
                    font-size: ${({ theme }) => theme.fontSizes.textTiny};
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};

                    &:hover,
                    &:focus-visible {
                        color: ${({ theme }) => theme.colors.white};
                        border: 1px solid ${({ theme }) => theme.colors.primary};
                        color: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        }
    }

    .properties {
        border-top: 1px solid ${({ theme }) => theme.colors.grey25};
        padding-top: ${rem(30)};

        @media (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(20)};
        }
    }

    .keys {
        margin: 0 0 ${rem(20)} 0;

        @media (min-width: ${breakpoints.md}px) {
            margin: 0 0 ${rem(20)} ${rem(20)};
        }

        .label {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            font-size: ${rem(18)};
            text-transform: uppercase;
            display: block;
        }

        .description {
            width: ${rem(220)};

            @media (min-width: ${breakpoints.xs}px) {
                width: ${rem(280)};
            }

            @media (min-width: ${breakpoints.md}px) {
                width: 100%;
            }
        }
    }

    .enginesAvailable,
    .colors,
    .interiorsAvailable,
    .featuresAvailable {
        margin: 0 0 ${rem(30)} 0;
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};

        .label {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            display: block;
        }

        .image {
            width: ${rem(280)};
            padding-top: ${rem(25)};
        }

        .sections {
            display: flex;
            padding-top: ${rem(25)};

            .engines,
            .styles,
            .interiors,
            .features {
                min-width: ${rem(280)};
                margin-right: ${rem(25)};

                @media (min-width: ${breakpoints.md}px) {
                    width: ${rem(280)};
                }

                .engine,
                .style,
                .interior,
                .feature {
                    padding-bottom: ${rem(25)};
                    color: ${({ theme }) => theme.colors.grey31};

                    .details {
                        display: block;
                        padding-bottom: ${rem(5)};
                        color: ${({ theme }) => theme.colors.black};
                    }

                    &.noExistInConfiguration {
                        visibility: hidden;
                    }

                    .name {
                        display: flex;
                        justify-content: space-between;
                        line-height: ${rem(16)};

                        svg {
                            width: ${rem(10)};
                            height: ${rem(10)};

                            path {
                                fill: ${({ theme }) => theme.colors.grey31};
                            }
                        }
                    }
                }
            }
        }
    }

    .featuresAvailable {
        @media (min-width: ${breakpoints.md}px) {
            margin: 0 0 ${rem(30)} ${rem(20)};
        }
    }

    .colors {
        .configurations {
            display: flex;
            flex-direction: column;
            padding: 0 0 ${rem(25)} ${rem(2)};
            width: ${rem(280)};
            margin-right: ${rem(20)};

            @media (min-width: ${breakpoints.md}px) {
                min-width: ${rem(280)};
            }

            img {
                width: ${rem(250)};
            }

            button {
                width: ${rem(40)};
                height: ${rem(40)};
                border: none;
                border-radius: 50%;
                margin: ${rem(20)} ${rem(5)} ${rem(10)} 0;
                border: 0.1rem solid ${({ theme }) => theme.colors.white};
                text-align: center;
                cursor: pointer;

                &.selected,
                &:hover {
                    border: 0.15rem solid ${({ theme }) => theme.colors.white};
                    box-shadow: 0px 0px 0px 0.1rem ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }

    .categories {
        display: flex;
        flex-wrap: wrap;
        padding: ${rem(20)} 0 ${rem(20)} 0;

        span {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            border: 1px solid ${({ theme }) => theme.colors.black};
            padding: ${rem(10)} ${rem(15)};
            cursor: pointer;
            border-radius: ${rem(4)};
            margin-right: ${rem(10)};
            white-space: nowrap;
            margin-bottom: ${rem(10)};

            &.selected,
            &:hover {
                background: rgba(0, 163, 224, 0.1);
                border: 1px solid ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .spinner {
        margin: ${rem(30)} 0;
    }
`;
